import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import AddIcon from "@material-ui/icons/Add";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import "date-fns";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { error } from "../../../../store/notification/actions";
import { getStoresAction } from "../../../../store/store/actions";
import { getSessionData } from "../../base/helper/baseHelper";
import MenuTableCell from "../../base/views/MenuTableCell";
import { Form, useForm } from "../../base/views/useForm";
import { editActiveUser, GetRole } from "./Helper/activeUserHelper";

const useStyles = makeStyles((theme) => ({
  dateStyle: {
    margin: theme.spacing(0, -5, 1),
  },
  bg: {
    display: "flex",
    justifyContent: "flex-start",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
    maxWidth: 200,
  },
  submit: {
    marginTop: "15px",
  },
}));

function EditActiveUser(props) {
  const initialFValues = {
    firstname: "",
    lastname: "",
    displayName: "",
    useremailid: "",
    jsoncol: [],
  };
  const userId = getSessionData({ key: "userId" });
  const { stores, getStores, addOrEdit, recordForEdit } = props;
  const [availableStores, setAvailableStores] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const [userRoles, setUserRoles] = useState([]);
  const classes = useStyles();
  const [filteredStores, setFilteredStores] = useState([]);
  const [lastSelected, setLastSelected] = useState(null);
  useEffect(() => {
    if (userId && !stores.length) getStores(userId);
    setAvailableStores([]);
  }, [userId, stores, getStores]);

  const validate = () => {
    const errors = userRoles.map((role) => {
      if (!role.role_pk) return true;
      else return false;
    });
    return errors.every((e) => !e);
  };

  const { values, setValues, resetForm } = useForm(
    initialFValues,
    true,
    validate
  );

  // const handleReset = async () => {
  //   await SendForgotPasswordMail({
  //     user_email: values.useremailid,
  //     redirect: true,
  //   });
  // };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      editActiveUser({ ...values, roles: userRoles, mainUser: userId }).then(
        (res) => {
          if (!res.hasError) {
            addOrEdit(res, resetForm);
            setUserRoles([]);
          }
        }
      );
    } else {
      error("Please select a role for the new stores");
    }
  };

  useEffect(() => {
    GetRole()
      .then((response) => {
        setRoleData(response);
      })
      .catch((err) => {});
    if (recordForEdit != null) {
      setValues({
        ...recordForEdit,
      });
      setUserRoles([...recordForEdit.jsoncol]);
      const uniqueStores = stores
        .filter(
          (store) =>
            !recordForEdit.jsoncol.some((s) => s.storeid === store.storeid)
        )
        .filter((store) => store.adminflag === "1");

      setFilteredStores([...uniqueStores]);
    }
  }, [recordForEdit, setValues, stores]);

  const handleRoleChange = (e, i) => {
    userRoles[i].role_pk = e.target.value.id;
  };
  const handleStoreChange = (e, i) => {
    if (lastSelected) {
      const newFilteredStores = filteredStores.filter(
        (item) => item.storeid !== lastSelected?.storeid
      );

      setFilteredStores(newFilteredStores);
    }

    const user = {
      role_pk: "",
      store_name: "",
      store_pk: "",
      storeid: "",
      user_type: "",
    };
    const newUserRoles = [...userRoles, user];
    setUserRoles(newUserRoles);
  };

  const handlePharmacyChange = (e, i) => {
    const store = e.target.value;
    setLastSelected(store);
    userRoles[i].store_name = store.storename;
    userRoles[i].store_pk = parseInt(store.storepk);
    userRoles[i].storeid = store.storeid;
  };
  const handleDelete = (storeid) => {
    const newFilteredStores = stores.filter((item) => item.storeid === storeid);
    setFilteredStores(newFilteredStores);
    setUserRoles(userRoles.filter((role) => role.storeid !== storeid));
    setLastSelected(null);
  };
  return (
    <Form>
      <div>
        <Container component="main" maxWidth="lg">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Button
                startIcon={<AddIcon />}
                variant="contained"
                onClick={handleStoreChange}
                style={{
                  background:
                    !filteredStores || !filteredStores.length
                      ? ""
                      : "rgb(22, 177, 255)",
                  color: "white",
                }}
                disabled={!filteredStores || !filteredStores.length}
              >
                Add New Pharmacy
              </Button>
            </Grid>
            <Grid item xs={12} className={classes.bg}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>Action</TableCell>
                    <TableCell>Pharmacy</TableCell>
                    <TableCell>Current Role</TableCell>
                    <TableCell>New Role</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userRoles?.map((store, i) => {
                    const s = availableStores.find(
                      (s) => s.storeid === store.storeid
                    );
                    let licenseAvailable = 1;
                    if (s) {
                      licenseAvailable =
                        s.licenseavailabe - Number(s.licenseused);

                      if (licenseAvailable === 0)
                        error(
                          "The selected store is out of license. Please purchase new License or deactivate any active user."
                        );
                    }
                    const role = roleData.find(
                      (r) => r.id === store.role_pk?.toString()
                    );
                    const storeData = stores.find(
                      (str) => str.storeid === store.storeid
                    );
                    return (
                      <TableRow key={i}>
                        <TableCell>
                          <IconButton
                            onClick={(e) => handleDelete(store.storeid)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                        {role ? (
                          <TableCell>{store.store_name}</TableCell>
                        ) : (
                          <MenuTableCell
                            onChange={(e) => {
                              // handleRoleChange(e, i);
                              handlePharmacyChange(e, i);
                            }}
                            disabled={licenseAvailable === 0}
                            value={storeData}
                          >
                            {filteredStores?.map((storeItem, j) => (
                              <MenuItem key={j} value={storeItem}>
                                {storeItem?.storename}
                              </MenuItem>
                            ))}
                          </MenuTableCell>
                        )}
                        <TableCell>{role?.roletype}</TableCell>
                        <MenuTableCell
                          onChange={(e) => {
                            handleRoleChange(e, i);
                          }}
                          disabled={licenseAvailable === 0}
                          value={role}
                        >
                          {roleData?.map((role, j) => (
                            <MenuItem key={j} value={role}>
                              {role?.roletype}
                            </MenuItem>
                          ))}
                        </MenuTableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Grid>
          </Grid>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              style={{ width: "20vw", background: "rgb(22, 177, 255)" }}
              type="submit"
              onClick={handleSubmit}
            >
              Save
            </Button>
          </div>
        </Container>
      </div>
    </Form>
  );
}

const mapStateToProps = (state) => {
  return { stores: state.store };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getStores: (userId) => dispatch(getStoresAction(userId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditActiveUser);
